module.exports = __webpack_public_path__ + "img/Maneki-Metamask-Conflux.09a9653f.png";